import { ref } from '@nuxtjs/composition-api';
import { PartsDbVehicleSummary, useVINSearch } from '@unified-commerce/gpc-vue-storefront-parts-db';

const useVehiclesByVin = () => {
  const vehicles = ref<PartsDbVehicleSummary[]>([]);
  const error = ref('');

  const { result, loading, getVehiclesByVIN, error: vinSearchError } = useVINSearch();

  const reset = () => {
    error.value = '';
    vehicles.value = [];
  };

  const fetchVehicles = async (vin: string) => {
    error.value = '';
    await getVehiclesByVIN(vin);

    if (result.value) {
      vehicles.value = result.value;
    }

    if (vinSearchError.value) {
      error.value = 'There is an issue getting your VIN number.';
    } else if (!vehicles.value.length) {
      error.value = 'Bike not found! Please enter correct VIN number';
    }
  };

  return {
    reset,
    vehicles,
    loading,
    fetchVehicles,
    error,
  };
};

export default useVehiclesByVin;
